import axios from 'axios'
import ramses from '../api/ramses'

const BASE_URL = process.env.VUE_APP_BASE_URL

async function auth() {
  const response = await axios.post(`${BASE_URL}users/authenticate`)
  return response
}

async function getMe() {
  try {
    const response = await axios.get(`${BASE_URL}users/me`)
    return response
  } catch (err) {
    
  }
}

async function getPermission(id) {
  try {
    const response = await axios.get(`${BASE_URL}admin/users/permissions/${id}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` } })
    return response
  } catch (err) {
    return err.response
  }
}

async function logout() {
  await axios.post(`${BASE_URL}users/logout`)
  sessionStorage.clear()
  window.location.href = '/'
}

async function login(email, password) {
  try {
    const response = await axios.post(`${BASE_URL}users/login`, {
      email,
      password,
    })

    const { status, data } = response

    if (status === 200) {
      const { token, permissions } = data

      if (permissions !== undefined) {
        response.status = 422
        return response
      }

      axios.defaults.headers.common.Authorization = `Bearer ${token}`
      ramses.defaults.headers.common.Authorization = `Bearer ${token}`
      sessionStorage.setItem('token', token)

      const responseAuth = await auth()
      if (responseAuth.status === 200) {
        await getPermission()
      }
    }
    return response
  } catch ({ response }) {
    return response
  }
}

async function changePassword(data) {
  try {
    const response = await axios.put(`${BASE_URL}users/change-password`, data)
    return response
  } catch ({ response }) {
    return response
  }
}

async function createPassword(data) {
  try {
    return await axios.put(`${BASE_URL}users/create-password`, data)
  } catch ({ response }) {
    return response
  }
}

async function forgotPassword(email) {
  try {
    const response = await axios.post(`${BASE_URL}users/recover-password`, {
      email,
    })
    return response
  } catch ({ response }) {
    return response
  }
}

async function resetPassword(hash, password) {
  try {
    const response = await axios.put(`${BASE_URL}users/reset-password/${hash}`, {
      new_password: password,
    })
    return response
  } catch ({ response }) {
    return response
  }
}

async function verifyHash(hash) {
  try {
    const response = await axios.get(`${BASE_URL}users/verify-hash/${hash}`)
    return response
  } catch ({ response }) {
    return response
  }
}

async function getMerchantGroupData(veripagId) {
  try {
    const response = await axios.get(`${BASE_URL}users/merchant-group-data/${veripagId}`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    })
    return response
  } catch ({ response }) {
    return response
  }
}

async function acceptTerms(data) {
  try {
    return await axios.post(`${BASE_URL}users/accept-terms`, data, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    })
  } catch ({ response }) {
    return response
  }
}

async function submitNps(data) {
  try {
    return await axios.post(`${BASE_URL}nps/review`, data, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    })
  } catch ({ response }) {
    return response
  }
}

export {
  logout,
  login,
  changePassword,
  createPassword,
  forgotPassword,
  resetPassword,
  verifyHash,
  getMerchantGroupData,
  getMe,
  getPermission,
  acceptTerms,
  submitNps,
}
